export const EMP_STATUS_ACTION = {
    RESET_EMP_STATUS_STATE: 'RESET_EMP_STATUS_STATE',
    EMP_STATUS_REQUEST: 'EMP_STATUS_REQUEST',
    EMP_STATUS_ERROR: 'EMP_STATUS_ERROR',
    EMP_STATUS_RESPONSE: 'EMP_STATUS_RESPONSE',

    RESET_GET_EMP_STATUS: "RESET_GET_EMP_STATUS",
    GET_EMP_STATUS_RESPONSE :"GET_EMP_STATUS_RESPONSE",
    GET_EMP_STATUS_REQUEST:"GET_EMP_STATUS_REQUEST",
    GET_EMP_STATUS_ERROR:"GET_EMP_STATUS_ERROR",

    RESET_DOC_TYPES_STATE: "RESET_DOC_TYPES_STATE",
    GET_DOCTYPE_RESPONSE :"GET_DOCTYPE_RESPONSE",
    GET_DOCTYPE_REQUEST:"GET_DOCTYPE_REQUEST",
    GET_DOCTYPE_ERROR:"GET_DOCTYPE_ERROR",

    RESET_DOCUMENT_UPLOAD_STATE: 'RESET_DOCUMENT_UPLOAD_STATE',
    REQUEST_DOCUMENT_UPLOAD: 'REQUEST_DOCUMENT_UPLOAD',
    RESPONSE_DOCUMENT_UPLOAD: 'RESPONSE_DOCUMENT_UPLOAD',
    ERROR_DOCUMENT_UPLOAD: 'ERROR_DOCUMENT_UPLOAD',
}


export const setResetDocumentUploadState= () => ({
  type: EMP_STATUS_ACTION.RESET_DOCUMENT_UPLOAD_STATE,
  data: undefined
});

export const requestDocumentUpload = (params) =>({
  type:EMP_STATUS_ACTION.REQUEST_DOCUMENT_UPLOAD,
  data: params
})
export const responseDocumentUpload = (res) => ({
  type: EMP_STATUS_ACTION.RESPONSE_DOCUMENT_UPLOAD,
  data: res
});

export const errorDocumentUpload = (err) => ({
  type: EMP_STATUS_ACTION.ERROR_DOCUMENT_UPLOAD,
  data: err
});

export const setResetDocTypesStatus= () => ({
  type: EMP_STATUS_ACTION.RESET_DOC_TYPES_STATE,
  data: undefined
});

export const requestDocTypesStatus = (params) =>({
  type:EMP_STATUS_ACTION.GET_DOCTYPE_REQUEST,
  data: params
})
export const responseDocTypesStatus = (res) => ({
  type: EMP_STATUS_ACTION.GET_DOCTYPE_RESPONSE,
  data: res
});

export const errorDocTypesStatus = (err) => ({
  type: EMP_STATUS_ACTION.GET_DOCTYPE_ERROR,
  data: err
});


 export const setResetEmpStatusState= () => ({
    type: EMP_STATUS_ACTION.RESET_EMP_STATUS_STATE,
    data: undefined
  });
  
  export const requestEmpStatus = (params) =>({
    type:EMP_STATUS_ACTION.EMP_STATUS_REQUEST,
    data: params
  })
  export const responseEmpStatus = (res) => ({
    type: EMP_STATUS_ACTION.EMP_STATUS_RESPONSE,
    data: res
  });
  
  export const errorEmpStatus = (err) => ({
    type: EMP_STATUS_ACTION.EMP_STATUS_ERROR,
    data: err
  });

  export const setResetGetEmpStatus= () => ({
    type: EMP_STATUS_ACTION.RESET_GET_EMP_STATUS,
    data: undefined
  });
  
  export const requestGetEmpStatus = (params ,silent = false) =>({
    type:EMP_STATUS_ACTION.GET_EMP_STATUS_REQUEST,
    data: params,
    silent,
  })
  export const responseGetEmpStatus = (res) => ({
    type: EMP_STATUS_ACTION.GET_EMP_STATUS_RESPONSE,
    data: res
  });
  
  export const errorGetEmpStatus = (err) => ({
    type: EMP_STATUS_ACTION.GET_EMP_STATUS_ERROR,
    data: err
  });

